<template>
    <select :disabled="readonly" v-model="displayValue" class="form-control" title="Ações do Monitor">
        <option :value="null">SELECIONE UMA AÇÃO</option>
        <option v-for="sn in rows" :value="sn" v-bind:key="sn.nome">{{ sn.nome }}</option>
    </select>
</template>

<script>
import { AtendimentoAcoes } from "../../class/index";

export default {
    name: "ComboAtendimentoAcoes",
    props: {
        value: {
            default: null
        },
        readonly: {
            default: false
        }
    },
    data() {
        return {
            rows: []
        };
    },
    computed: {
        displayValue: {
            get: function() {
                return this.value;
            },
            set: function(modifiedValue) {
                this.$emit("input", modifiedValue);
            }
        }
    },
    beforeMount() {
        AtendimentoAcoes.all()
            .then(rows => {
                this.rows = rows;
            })
            .catch(err => console.error(err));
    }
};
</script>

<style scoped>
</style>
